<script>
    import {GPTypeCustomStructure} from "./gp-typecustomstructure";
    import {activePickerItem, activePickerStructureVariant} from './gp-context-items';
    import jQuery from "jquery";
    import {onMount} from "svelte";
    import "./libs/jquery-ui.min.js";
    import "./libs/jquery.ui.touch-punch.min.js";

    export let structure;
    let domThis;
    $: custom = structure.type === "custom";
    $: cssHSVStyle = $activePickerStructureVariant ? "filter: hue-rotate(-"+$activePickerStructureVariant.h+"deg) saturate("+(1+$activePickerStructureVariant.s / 3)+") brightness("+(1+$activePickerStructureVariant.v / 2)+")" : '';
    $: $activePickerStructureVariant = $activePickerItem? null : null; //refreshing when changed

    function selectItem(structure) {
        $activePickerItem = structure;
    }

    onMount(() => {
        jQuery(domThis).find('img').draggable({
            opacity: 0.7,
            helper: function (el) {
                return jQuery(el.target).closest('.GPStructurePickerItem').find('img').clone()
            },
            cursorAt: {bottom: -3, left: 0},
            start: () => selectItem(structure),
            appendTo: "body"
        });
    })
</script>


<div on:click={() => selectItem(structure)}
     role="button"
     class="list-group-item GPStructurePickerItem"
     class:premiumDisabled={!structure.enabled}
     class:enabled={structure.enabled}
     class:selected={$activePickerItem===structure}
     class:custom
     bind:this={domThis}
     GPItem="{structure.id}">

    <img class="GPStructurePickerImage" style='{$activePickerItem===structure ? cssHSVStyle : ""}' src="{structure.staticGetPathForThumb()}"/>
    <div class="GPStructurePickerItemName">{@html structure.displayName}</div>
    {#if $activePickerItem===structure}
        {#if !custom}
            <a on:click={() => {GP.app.showDetailsOfItem($activePickerItem)}} class="helpIcon">
                <i class="fa fa-question-circle"></i>
            </a>
        {/if}
        {#if custom}
            <a on:click={() => {let evt = new CustomEvent('deleteCustomObject', {detail: structure.id}); window.dispatchEvent(evt)}} class="deleteIcon">
                <i class="fa fa-minus-circle"></i>
            </a>
        {/if}
    {/if}
</div>